module.exports = __webpack_public_path__ + "media/images/shared/icon_clip-0c8e0fc558e5373dcb5aa61c976975b2.png";